import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImportDatabaseComponent } from './import-database.component';



@NgModule({
  declarations: [
    ImportDatabaseComponent
  ],
  imports: [
    CommonModule
  ]
})
export class ImportDatabaseModule { }
